<template>
  <nav class="fixed header-shadow bg-white" style="z-index: 99;">
    <div class="m-w nav-line">
      <img class="logo" src="/static/img/logo.svg" />
      <div class="a-href-list font24">
        <router-link
          v-for="(item, $index) in items"
          :key="$index"
          :class="{ select: selected($index),'lighter': true }"
          tag="a"
          :to="item.href"
          @click.native="selectClass($index)">
          {{item.name}}
        </router-link>
        <div class="line">
                    <span class="dot">

                    </span>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
  import {ScrollToTop} from '@/api/scroll'

  export default {
    data(){
      return{
        selectedIndex: 0,
        items: [
          { name: "未来已来", href: "/" },
          { name: "智慧小超", href: "/intelmarket" },
          { name: "无人零售", href: "/unmannedstore" },
          { name: "合作加盟", href: "/partner" },
          { name: "新闻资讯", href: "/news" },
          { name: "关于我们", href: "/aboutus" }
        ]
      }
    },
    created() {
      this.setSelectedIndex();
    },
    mounted() {

    },
    methods: {
      selectClass(index) {
        ScrollToTop();
        this.selectedIndex = index;
      },
      setSelectedIndex() {
        if(this.$route.path.endsWith('/')) {
          this.selectedIndex = 0;
        }else{
          this.items.find((item,index,arr)=> {
            if(index == 0) return false;

            if(this.$route.path.indexOf(item.href) !== -1) {
              this.selectedIndex = index;

              return true;
            }else return false;
          })
        }
      },
      selected($index) {
        return this.selectedIndex == $index;
      }
    }
  }
</script>

<style scoped>
  .header-shadow{
    box-shadow: 0 3px 6px rgba(0,0,0,0.16);
  }

  .logo{
    width: 150px;
    height: 150px;
    float:left;
    position: absolute;
  }

  .a-href-list{
    float: right;
    height: inherit;
    min-height: inherit;
    display: flex;
    position: relative;
  }

  .a-href-list a{
    display: block;
    height: inherit;
    min-height: inherit;
    display: flex;
    align-items: center;
    padding: 0 20px;
  }

  .a-href-list a,.a-href-list a:hover{
    text-decoration: none;
    color: #000;
  }

  .a-href-list a.select{
    color: #FF2A00;
  }

  .line{
    position: absolute;
    width: 100%;
    height: 1px;
    left:0;
    bottom: 15%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue